module.exports = __webpack_public_path__ + "static/media/step3.0cac4aaa.png";